module.exports = __webpack_public_path__ + "static/img/index18.a984a89.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index18.gif
// module id = P3No
// module chunks = 0